/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import L from "../Lang";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import PaymentCom from "./PaymentCom";
import LoadingAlert from "../LoadingAlert";
import Alert from "../Alert";
import Globals from "../../shared/Globals";
import React from "react";
import { qreq } from "../../shared/qrequest";

class Method extends BaseCom {

    render() {
        return <div className={this.props.expand ? 'col-xl-12 col-lg-12 col-12' : 'col-xl-6 col-lg-12 col-12'}>
            <div ref={this.props.ref} role="button" onClick={this.props.ref ? null : this.props.onSelect} className={'text-center custom-btn-size-sm p-3 mb-4' + (this.props.appendClassName ? ' ' + this.props.appendClassName : '')}>
                <div className="smallscreen-btn-adjust">
                    <img src={`/assets/img/${this.props.img}`} className="img-fluid" alt={'Pay with ' + this.props.type} />
                </div>
            </div>
        </div>;
    }
}

class PaymentMethod extends PaymentCom {

    constructor(props) {
        super(props);
        this.state = {};
        this.containerRef = React.createRef();
    }

    async componentDidMount() {
        await this.getAvailable();
        const session = await this.loadSession(this.props.params.sid);
        const merchant = await this.loadMerchant(session);
        //console.log('merchant', merchant);
        this.setState({ apPagePath: '/pages/apple-pay.html?sd=' + Globals.toEnc(JSON.stringify(session)) + '&m=' + Globals.toEnc(merchant.merchantname) });
        this.ap_button(merchant);
    }

    ap_button = (merchant) => {
        const _self = this;
        if (this.containerRef.current.hasClickEvent) return;
        this.containerRef.current.addEventListener('click', (e) => {
            e?.preventDefault();
            try {
                if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
                    const merchantId = _self.state.session.merchantID;
                    const terminalId = _self.state.session.terminalID;
                    const merchantName = merchant.merchantname;

                    // Apple Pay expects amount as a string with 2 decimals
                    const chargeAmount = String((Math.round(_self.state.session.total * 100) / 100).toFixed(2));

                    const paymentRequest = {
                        countryCode: 'US',
                        currencyCode: 'USD',
                        supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
                        merchantCapabilities: ['supports3DS'],
                        total: { label: merchantName, amount: chargeAmount },

                        requiredBillingContactFields: ['postalAddress', 'name', 'phone', 'email'],
                        requiredShippingContactFields: ['postalAddress', 'name', 'phone', 'email'],
                    };

                    const session = new window.ApplePaySession(3, paymentRequest);

                    // Use arrow functions so `this` stays correct (no _self needed)
                    session.onvalidatemerchant = async (event) => {
                        try {
                            const data = {
                                ..._self.state.session,
                                ..._self.state.merchant,
                                validationURL: event.validationURL,
                            };

                            // Backend should return the raw merchant session from Apple
                            // e.g. { item: <appleMerchantSessionObject> } or just <object>
                            const j = await qreq.postAsync('/api/payment/validate/apple', data);

                            const merchantSession =
                                j?.item?.merchantSession || j?.item || j; // tolerate a few shapes

                            session.completeMerchantValidation(merchantSession);
                        } catch (err) {
                            console.error('[ApplePay] merchant validation error:', err);
                            session.abort(); // safer than completePayment here
                        }
                    };

                    session.onpaymentmethodselected = (event) => {
                        // v3 generally expects (newTotal, newLineItems)
                        session.completePaymentMethodSelection(
                            { label: merchantName, amount: chargeAmount, type: 'final' },
                            [{ label: 'Charged Amount', amount: chargeAmount, type: 'final' }]
                        );
                    };

                    session.onshippingmethodselected = (event) => {
                        // v3 generally expects (status, newTotal, newLineItems)
                        session.completeShippingMethodSelection(
                            window.ApplePaySession.STATUS_SUCCESS,
                            { label: merchantName, amount: chargeAmount, type: 'final' },
                            [{ label: 'Charged Amount', amount: chargeAmount, type: 'final' }]
                        );
                    };

                    session.onpaymentauthorized = async (event) => {
                        try {
                            const token = await window.loginToken(merchantId, terminalId);
                            if (!token) {
                                session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                                return;
                            }

                            // IMPORTANT: send Apple payment token to your server
                            // event.payment.token.paymentData is the encrypted payload
                            const info = {
                                ..._self.state.session,
                                processType: 'ap',
                                applePay: {
                                    billingContact: event.payment.billingContact,
                                    shippingContact: event.payment.shippingContact,
                                    token: event.payment.token, // send full token (or at least token.paymentData)
                                },
                            };

                            const j = await qreq.postAsync('/api/payment/process', info);

                            if (j?.item) {
                                _self.props.onSuccess(j.item);
                                session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
                                _self.props.navigate(`/gateway/${_self.props.params.sid}/success`);
                            } else {
                                _self.props.onError(j?.errorMessage || 'Payment failed');
                                session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                            }
                        } catch (e) {
                            console.error('[ApplePay] process error:', e);
                            _self.unkownErrorCallback(e);
                            session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                        }
                    };

                    session.oncancel = (e) => console.log('Apple Pay session cancelled', e);

                    session.begin();
                }




            }
            catch (e) {
                console.error(e);
            }
        });
        this.containerRef.current.hasClickEvent = true;
    }


    ap_pay = async (e) => {
        let token = e.paymentMethodData.tokenizationData.token;
        console.log("Token sent", token);

        let info = { ...this.state.info };
        info.processType = 'ap';
        info.amount = this.props.session.amount;
        info.totalTax = this.props.session.totalTax;
        info.sid = this.props.session.sid;
        info.payToken = token;

        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    select = (method) => {
        this.props.navigate(`/gateway/${this.props.params.sid}/payment/${method}`);
    }

    render() {
        if (!this.state.session) {
            if (this.state.error)
                return <Alert type="danger">{this.state.error}</Alert>;
            return <LoadingAlert />;
        }
        return <div className="payment-method container-fluid py-3">
            <h2><L>Please Choose a Payment Method</L></h2>
            <div className="row">
                <div className="col-md-6">
                    <h4><L>Summary</L></h4>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>Sub-total</td>
                                <td>{Globals.formatPrice(this.state.session?.amount)}</td>
                            </tr>
                            <tr>
                                <td>Tax</td>
                                <td>{Globals.formatPrice(this.state.session?.tax)}</td>
                            </tr>
                            <tr>
                                <td>Total (USD)</td>
                                <td><strong>{Globals.formatPrice(this.state.session?.total)}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-md-6">
                    <div className="row">
                        {this.state.methods.creditCard && <Method type="Credit Card" name={<L>Credit Card</L>} onSelect={() => this.select('cc')} img="pm/cc.png" />}
                        {this.state.methods.giftCard && <Method type="Gift Card" name={<L>Gift Card</L>} onSelect={() => this.select('gc')} img="pm/gc.png" />}
                        {this.state.methods.applePay && window.ApplePaySession && <div className="col-xl-6 col-lg-12 col-12">
                            <div ref={this.containerRef} role="button" className="text-center custom-btn-size-sm p-3 mb-4" id="apple-pay-button">
                                <div className="smallscreen-btn-adjust">
                                    <img src="/assets/img/pm/ap.png" className="img-fluid" alt="Pay with Apple" />
                                </div>
                            </div>
                            {/*<div role="button" className="text-center custom-btn-size-sm p-3 mb-4">
                                {this.state.apPagePath && <iframe src={this.state.apPagePath} title="Apply Pay" width="100%" height="62px" style={{ border: 'none', overflow: 'hidden' }} />}
                            </div>*/}
                        </div>}

                        {this.state.methods.googlePay && <Method type="Google Pay" name={<L>Pay with</L>} onSelect={() => this.select('gp')} img="pm/gp.png" appendClassName="custom-gpay-btn" />}
                        {this.state.methods.athMovil && this.state.merchant?.isATHenable && <Method type="ATH Movil" name={<L>Pay with</L>} onSelect={() => this.select('am')} img="pm/am.png" />}
                        {this.state.methods.payByBank && <Method type="Bank" name={<L>Pay by Bank</L>} onSelect={() => this.select('bk')} img="pm/bk.png" />}
                    </div>
                </div>
            </div>

        </div>;
    }
}

export default withParamsAndNavigate(PaymentMethod);